import type { AssetHandler } from '../../assetTypes';
import type { DropPayload } from '../../dragDropTypes';
import type { IAssetFile } from '../assetHandler';
import type * as THREE from 'three';

import { store } from '@/app/editor/store';

export class SourceCodeHandler implements AssetHandler {
  async handleSelect(asset: IAssetFile): Promise<void> {
    store.setSelectedAssetItem(asset);
  }

  async handleOpen(asset: IAssetFile): Promise<void> {
    // open link in new tab
    window.open('cursor://file/' + asset.absolutePath.replace(/\\/g, '/'));
  }

  async handleDragEnter(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDragOver(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDragCancel(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  async handleDrop(worldPosition: THREE.Vector3, payload: DropPayload): Promise<void> {
  }

  getTargetObject(): unknown {
    return undefined;
  }
}
